module.exports = __webpack_public_path__ + "static/applepay-logo-small-62d2dfd33944c3737dc1968e128a3f96.svg";